import React, { useCallback } from 'react';

import CommonButton from '../common/components/CommonButton';
import { CommonButtonVariants } from '../constants/CommonButtonVariants';
import RouterPaths from '../constants/RouterPaths';
import Image from '../assets/img/404_photo.svg';
import { customNavigate } from '../common/hooks/useCustomNavigate';

function NotFound() {
  const handleHomeClick = useCallback(() => {
    customNavigate(RouterPaths.HOMEPAGE);
  }, []);

  return (
    <div className="auth__page">
      <div className="auth__container">
        <div className="auth__credentials-section notFound__section">
          <div className="">
            <div className="">
              <h3 className="auth__heading">404 – Page not found</h3>
              <p className="auth__login-description">
                Looks like this road leads nowhere... The page you&apos;re looking for may have
                been removed, had its name changed, or is temporarily unavailable.
                <br />
                <br />
                Go back and try searching for your perfect vehicle again.
              </p>
            </div>
            <CommonButton
              label="Home page"
              handleClick={handleHomeClick}
              className="register-form-success-button auth__homepage-button"
              variant={CommonButtonVariants.OUTLINED_RED}
            />
          </div>
          <div className="not-found-image">
            <img src={Image} alt="404 Not Found" />
          </div>
        </div>
      </div>
    </div>
  );
}
export default NotFound;
